import { sendAmplitudeEvent, sendGoogleEvent, smoothScroll } from '@html/_common/utils';

import AOTourBookingIntent from '@atomic/organisms/tour_b/shared/js/booking-intent-cta';
import TourWishlist from '@app/_common/tour-wishlist/wishlist';
import TourCategory from '@scout/components/tour-category/tour-category';
import TourRadarMembershipPopup from '@atomic/organisms/tour_b/tourradar-membership/tourradar-membership-popup';
import AOTourPriceGuaranteePopup from '@atomic/organisms/tour_b/price-guarantee/price-guarantee-popup';
import AOTourPricePayByInstallmentsPopup from '@atomic/organisms/tour_b/pay-by-installments/pay-by-installments-popup';

export default class AOTourAboveFold {
  $SHOW_MORE_SELECTOR = '.js-ao-tour-above-fold__properties-list--show-more';

  $OTHER_LANGUAGES_SELECTOR = '.js-ao-tour-above-fold__properties-list--other-languages';

  $CONTAINER_SELECTOR = '.js-ao-tour-keep-exploring';

  $PRICE_BASED_ON_SELECTOR = '.js-ao-tour-above-fold__price-based-on-text--departure-label';

  $INSTALLMENTS_SELECTOR = '.ao-tour-above-fold__installments';

  constructor(tourId, eventCategory, scrollTo) {
    this.tourId = tourId;
    this.eventCategory = eventCategory;
    this.scrollTo = scrollTo;

    // Get payment plan data from data attributes
    const $installmentsEl = $('.ao-tour-above-fold__installments');
    const paymentInfo = {
      noFeesText: $installmentsEl.data('trans-no-fees-text') || '',
      departureDate: $installmentsEl.data('trans-departure-date') || '',
      departureDateRaw: $installmentsEl.data('trans-departure-date-raw') || '',
      payTodayText: $installmentsEl.data('trans-pay-today-text') || '',
      paymentPlanText: $installmentsEl.data('trans-payment-plan-text') || '',
    };

    this.bookIntent = new AOTourBookingIntent(eventCategory, scrollTo);
    this.priceGuaranteePopup = new AOTourPriceGuaranteePopup(eventCategory);
    this.payByInstallmentsPopup = new AOTourPricePayByInstallmentsPopup(eventCategory, paymentInfo);
  }

  init() {
    this.bookIntent.init();
    this.priceGuaranteePopup.init();
    this.payByInstallmentsPopup.init();
    this.initRatingHandler();
    this.initTourWishlist();
    this.initShowMore();
    this.initiateTourRadarMembership();
    this.initPriceBasedOn();
    TourCategory({ containerSelector: this.$CONTAINER_SELECTOR });
  }

  static getActionBarClassName() {
    return 'ao-tour-above-fold__action-bar';
  }

  initiateTourRadarMembership() {
    this.tourRadarMembership = TourRadarMembershipPopup(
      {
        open: {
          ampEventName: 'price_block_modal_opened',
          price_block_modal: 'TourRadar+',
        },
      },
    );
    this.tourRadarMembership.initiate();
  }

  initRatingHandler() {
    const $ratings = $('.js-ao-tour-above-fold__rating');
    const gaEventLabel = 'Tour Snapshot Click';

    $ratings.each((index, ratingElement) => {
      const $rating = $(ratingElement);
      const reviewsAvailable = $rating.data('reviews');

      $rating.on('click', () => {
        if (reviewsAvailable === 'tour') {
          this.scrollTo('reviews', 'Reviews', gaEventLabel);
        } else if (reviewsAvailable === 'operator') {
          this.scrollTo('operator', 'Operator', gaEventLabel);
        }
      });
    });
  }

  initTourWishlist() {
    const $tourName = $('.js-ao-tour-above-fold__tour-name');

    const label = $tourName.length ? $tourName.data('full-name').trim() : 'No Tour Name';
    const googleEventData = { category: 'TDP', label };

    const title = $tourName.text()?.trim();
    const heartSelector = '.js-ao-tour-above-fold__icon-button-wishlist,.js-ao-tour-bottom-banner__cta-favourite';

    const tooltipSelector = '.js-wishlist-icon__tooltip';

    TourWishlist({
      googleEventData, title, heartSelector, tooltipSelector, getId: () => this.tourId, isMultipleHearts: true,
    });
  }

  initShowMore() {
    $(this.$SHOW_MORE_SELECTOR).on('click', () => {
      $(this.$SHOW_MORE_SELECTOR).addClass('hid');
      $(this.$OTHER_LANGUAGES_SELECTOR).removeClass('hid');

      sendGoogleEvent(
        'TDP',
        'More Languages',
        'Tour Snapshot',
      );
    });
  }

  initPriceBasedOn() {
    const $body = $('body');

    $body.on('click', this.$PRICE_BASED_ON_SELECTOR, (event) => {
      const $priceBasedOnAnchorElement = $(event.currentTarget);
      const departure = $priceBasedOnAnchorElement.data('departure');
      const fullDate = $priceBasedOnAnchorElement.data('full-date');

      const departureMonthFilterButtonSelector = '.js-ao-tour-availability__filters-button';
      const currentDepartureMonth = $(`${departureMonthFilterButtonSelector}[data-val="${departure}"]`);

      // Click the month filter first
      currentDepartureMonth.click();

      const $availabilitySection = $('.js-ao-tour-availability__filters');

      if ($availabilitySection.length) {
        // First scroll to the availability section
        smoothScroll({
          to: $availabilitySection,
          duration: 1000,
        });

        // After clicking month filter, wait for date cards to load
        setTimeout(() => {
          // Convert the full date to the format used in data-parameter (DD.MM.YYYY)
          const dateParts = fullDate.split('-');
          const formattedDate = `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;

          // Try to find the card by looking for buttons with matching date parameter
          const $dateCard = $(`.js-am-tour-availability__variant button[data-parameter*="date=${formattedDate}"]`).closest('.js-am-tour-availability__variant');

          if ($dateCard.length) {
            smoothScroll({
              to: $dateCard,
              duration: 300,
            });
          }
        }, 1000); // Wait 500ms for cards to load
      }

      sendAmplitudeEvent({
        ampEventName: 'tdp_price_based_on_clicked',
      });
    });
  }
}
